const API_ENDPOINT = 'UserPatientProfileWebPushNotifications';

export const API_USER_PATIENT_PROFILE_WEB_PUSH_NOTIFICATIONS = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: Pick<UserPatientProfileWebPushNotification, 'id'>) =>
    `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<UserPatientProfileWebPushNotification, 'id'>) =>
    `${API_ENDPOINT}/Delete/${data.id}`,
};

export interface UserPatientProfileWebPushNotification {
  id: string;
  rowIndex: number;
  isActive: boolean;
  userPatientProfileID: string;
  subscription: string;
}
